<script setup>
import { ref, onMounted } from 'vue';
import { router } from '@inertiajs/vue3';
import { useDisplay } from 'vuetify';
import { useUserStore } from '@/stores/user';
import { storeToRefs } from 'pinia';

defineOptions({
    inheritAttrs: false
});

const drawer = ref(true);
const { thresholds } = useDisplay();

onMounted(() => {
    if (window.innerWidth <= thresholds.value.md) {
        drawer.value = false;
    }
});

const logout = async () => {
    await router.post('/logout');
};

const { profile } = storeToRefs(useUserStore());
</script>

<template>
<div>
    <v-app>
        <v-app-bar app>
            <div class="flex justify-between w-full items-center px-4">
                <img
                    class="block h-12 object-scale-down cursor-pointer"
                    src="/images/logo-k.png"
                    alt="Logo"
                    @click="$inertia.visit('/')">

                <div class="flex gap-4">
                    <img

                        class="block h-12 w-12 mt-2 rounded-full"
                        src="/images/profile.png"
                        alt="Logo">
                    <div class="hidden sm:flex flex-col justify-center text-sm border-r pr-4 border-grey-300">
                        <span v-if="profile">{{ profile.first_name }}</span>
                        <span v-if="profile" class="-mt-0.5">{{ profile.last_name }}</span>
                    </div>
                    <v-list>
                        <v-list-item
                            v-if="profile"
                            title="Sign Out"
                            class="flex justify-end self-end"
                            value="logout"
                            @click.prevent="logout">
                            <template #prepend>
                                <v-icon icon="mdi-power-standby" />
                            </template>
                        </v-list-item>
                        <v-list-item
                            v-else
                            title="Sign Up"
                            class="flex justify-end self-end"
                            value="logout"
                            @click.prevent="$inertia.visit('/register')">
                            <template #prepend>
                                <v-icon icon="mdi-account-plus" />
                            </template>
                        </v-list-item>
                    </v-list>
                </div>
            </div>
        </v-app-bar>

        <v-main app class="bg-primary-light">
            <slot />
        </v-main>

        <div class="z-[1008]">
            <modals-container />
        </div>
    </v-app>
</div>
</template>
